import React from "react";
import DemoPage from "@/components/DemoPage";

const DemoUB04 = () => (
  <DemoPage
    seo={{
      title: "Demo: UB-04 / CMS-1450 Extraction | See Hewto.ai in Action",
      description:
        "Watch Hewto.ai capture, validate, and structure data from a UB-04 / CMS-1450 institutional claim form in real time — revenue codes, line items, and charges to a validated 837I. Book a personalized demo on your own claims.",
      keywords:
        "ub-04 demo, cms-1450 ocr demo, ub04 extraction demo, institutional claim ocr demo, 837i demo, healthcare document ai demo",
      canonical: "https://www.hewto.ai/demo/ub-04-cms-1450",
    }}
    heading="Demo"
    intro="See Hewto.ai automate UB-04 / CMS-1450 institutional claims. Our AI captures revenue codes, line items, and charge details — validated and 837I-ready in seconds."
    videoId="aNJopP_WRWc"
    videoTitle="Hewto.ai — Handwritten UB-04 / CMS-1450 demo"
    source="demo_ub04_cms1450"
  />
);

export default DemoUB04;
